import {PIXI} from '@colonist/pixi'

import {UIUtilsEjsVariables} from '../../../../shared/scripts/UIUtilsEjsVariables'
import {UIGameTradeCreationController} from '../../../../shared/scripts/trade/ui_trade_creation/UIGameTradeCreationController'
import {SectionBgView} from '../../../../shared/scripts/ui_canvas_engine/SectionBgView'

export class UIMGameTradeCreationController extends UIGameTradeCreationController {
    protected getContainer(): SectionBgView {
        const shouldRenderForTabletApp = UIUtilsEjsVariables.isUserOnTabletApp && UIUtilsEjsVariables.shouldDisplayNewMobileGameUI

        const canvas = this.uiGameManager.canvasController
        const w = shouldRenderForTabletApp ? canvas.appW / 2 + canvas.itemSize : canvas.appW
        const h = canvas.itemSize * 2
        const x = 0
        const y = canvas.appH - canvas.itemSize * 1.75 - h
        const container = new SectionBgView(x, y, w, h, canvas.app.stage, true)
        container.drawBg(0x000000, 0.01)
        container.interactive = true
        container.on('pointerdown', (e: PIXI.FederatedEvent) => {
            e.stopPropagation()
        })
        return container
    }
}
